import { createSelector } from "reselect";
import get from "lodash/get";

export const getApiTokens = (_, props) => {
  return get(props, "data.viewer.account.apiTokens.edges", [])
    .filter(d => d.node.permissions !== "Read Only")
    .map(d => {
      let newName = d.node.name + " | ( " + d.node.permissions + " )";
      if (!d.node.active) {
        newName += " | ( disabled )";
      }

      return {
        token: d.node.token,
        name: newName,
        environment: d.node.environment,
      };
    })
    .sort((currentElement, previousElement) =>
      currentElement.name.localeCompare(previousElement.name)
    );
};

export const getEnvironmentsWithTokensCount = createSelector(
  [getApiTokens],
  tokens => {
    return tokens.map(e => e.environment).filter(x => x).length;
  }
);
